export function CTLogo({ className = "size-6" }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 80 80"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
    >
      {/* Film strip body */}
      <rect x="8" y="14" width="64" height="52" rx="12" fill="#7c5cbf" stroke="#000" strokeWidth="4" />
      {/* Sprocket holes left */}
      <rect x="14" y="22" width="8" height="6" rx="2" fill="#000" />
      <rect x="14" y="34" width="8" height="6" rx="2" fill="#000" />
      <rect x="14" y="46" width="8" height="6" rx="2" fill="#000" />
      {/* Sprocket holes right */}
      <rect x="58" y="22" width="8" height="6" rx="2" fill="#000" />
      <rect x="58" y="34" width="8" height="6" rx="2" fill="#000" />
      <rect x="58" y="46" width="8" height="6" rx="2" fill="#000" />
      {/* Screen / play area */}
      <rect x="26" y="22" width="28" height="22" rx="4" fill="#b8a5f0" stroke="#000" strokeWidth="3" />
      {/* Play triangle */}
      <path d="M36 28 L36 40 L47 34 Z" fill="#000" />
      {/* Cartoon eyes on top */}
      <circle cx="30" cy="10" r="7" fill="#fff" stroke="#000" strokeWidth="3" />
      <circle cx="50" cy="10" r="7" fill="#fff" stroke="#000" strokeWidth="3" />
      <circle cx="32" cy="9" r="3" fill="#000" />
      <circle cx="52" cy="9" r="3" fill="#000" />
      {/* Sparkle */}
      <path d="M62 4 L64 8 L68 6 L64 10 L68 12 L64 12 L62 16 L60 12 L56 12 L60 10 L56 6 L60 8 Z" fill="#b8a5f0" stroke="#000" strokeWidth="1.5" />
      {/* Smile under screen */}
      <path d="M34 50 Q40 56 46 50" stroke="#000" strokeWidth="3" strokeLinecap="round" fill="none" />
    </svg>
  );
}
